export default __webpack_public_path__ + "static/media/athena-mod.214c31b2.png";